import {isString} from 'ldash'
import {SILENT, createAction} from 'uix/actions'

// load from server
export let loadStatesConfig = createAction(
  'LOAD_STATES_CFG',
  (dname, statusType) => ({
    dname,
    statusType,
  }),
  SILENT
)

// write to store
export let setStatesConfig = createAction('SET_STATES_CFG', (dname, data) => ({dname, data}))

export let setStateMany = createAction(
  'SET_STATES_MANY',
  (otids, statusType, statusValue, affectedParts) => ({
    otids,
    statusType,
    statusValue,
    affectedParts: isString(affectedParts) ? [affectedParts] : affectedParts,
  })
)
